import { CompanyEventEnumType } from '__generated__/graphql';

export default function companyEventTypeToReadable(type: CompanyEventEnumType): {
  label: string;
  color: string;
} {
  switch (type) {
    case CompanyEventEnumType.TransactionalDocuments:
      return {
        label: 'Transactional Documents',
        color: 'indigo',
      };
    case CompanyEventEnumType.AncillaryDocuments:
      return {
        label: 'Ancillary Documents',
        color: 'red',
      };
    case CompanyEventEnumType.RegulatoryDocuments:
      return {
        label: 'Regulatory Documents',
        color: 'blue',
      };
    case CompanyEventEnumType.ApprovalDocuments:
      return {
        label: 'Approval Documents',
        color: 'green',
      };
    case CompanyEventEnumType.Others:
      return {
        label: 'Others',
        color: 'amber',
      };
    default:
      return {
        label: type,
        color: 'gray',
      };
  }
}
